import * as MD from '@material-ui/core';
import { SvgIcon } from '@material-ui/core';
import MuiTextField from '@material-ui/core/TextField';
import { Autocomplete, AutocompleteRenderInputParams } from '@material-ui/lab/';
import * as React from 'react';
import 'react-phone-input-2/lib/material.css';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { Dispatch } from 'redux';
import styled from 'styled-components';
import { IApplicationState, IConnectedReduxProps } from '../../Store';
import { I18N } from '../../Store/I18n/Types';
import { IUserState } from '../../Store/User/Types';
import {
	addACLResource,
	getACLResourcesParents,
	getACLResourcesTypes,
} from '../../Store/ResourcesManagement/Actions';
import { IResourcesManagementState } from '../../Store/ResourcesManagement/Types';
import { getTheme } from '../../Themes';
import { YacastLogoIcon } from '../../Themes/svg/yacast-logo';
import {
	isNullOrUndefined,
	isNullOrUndefinedOrEmptyString,
} from '../../Utils/Various';
import { red } from '@material-ui/core/colors';

export interface IRouterMatchParams {
	groupName: string;
	type: string;
}

interface IPropsFromState {
	i18n: I18N;
	router: RouteComponentProps<IRouterMatchParams>;
	user: IUserState;
	resourcesManagement: IResourcesManagementState;
	isCreatingResource: boolean;
}

interface IPropsFromDispatch {
	getACLResourcesParents: typeof getACLResourcesParents;
	getACLResourcesTypes: typeof getACLResourcesTypes;
	addACLResource: typeof addACLResource;
}

interface IState {
	errorCreation: boolean;
	errorCreationdMsg: string;
	params: {
		name: string;
		type: number;
		typeName: string;
		isparent: boolean;
		parentID: number;
		parentName: string;
	};
	errorStartDate: boolean;
	resourceHasParent: boolean;
	errors: {
		name: boolean;
		type: boolean;
		parent: boolean;
	};
}

const initialState = {
	errorCreation: false,
	errorCreationdMsg: '',
	params: {
		name: '',
		type: -1,
		typeName: '',
		isparent: false,
		parentID: -1,
		parentName: '',
	},
	errorStartDate: false,
	resourceHasParent: true,
	errors: {
		name: false,
		type: false,
		parent: false,
	},
};

type AllProps = MD.WithStyles<typeof styles> &
	IPropsFromState &
	IPropsFromDispatch &
	RouteComponentProps<{}> &
	IConnectedReduxProps;

const theme = getTheme();

const styles = MD.createStyles({
	button: {
		margin: theme.spacing(1),
		marginLeft: 0,
		marginRight: 0,
		textTransform: 'uppercase',
	},
	card: {
		maxWidth: '55%',
		minWidth: '20%',
		margin: 'auto',
		marginTop: '3%',
	},
	cardContent: {
		width: '100%',
	},
	form: {
		display: 'flex',
		flexDirection: 'column',
		flexWrap: 'wrap',
	},
	label: {
		paddingTop: '15px',
	},
	required: {
		color: red[500],
		marginLeft: 2,
	},
	formError: {
		color: red[500],
		fontSize: '0.75rem',
		marginTop: 3,
	},
});

const DensedTextField = styled(MuiTextField)`
	.MuiInputBase-input {
		padding: 4px 6px;
		font-size: 13px;
	}
	.MuiInputLabel-formControl {
		top: -7px;
		font-size: 13px;
		font-weight: 300;
	}
`;

export class ResourceManagementCreationComponent extends React.Component<
	AllProps,
	IState
> {
	public constructor(props: AllProps) {
		super(props);
		this.state = {
			...initialState,
		};
	}

	public componentDidMount() {
		this.props.getACLResourcesParents(this.props.user.token);
		this.props.getACLResourcesTypes(this.props.user.token);
	}

	public render(): React.ReactNode {
		const { classes } = this.props;
		return (
			<React.Fragment>
				<MD.Card className={classes.card}>
					<MD.CardActionArea></MD.CardActionArea>
					<MD.CardActions>
						<MD.CardContent className={classes.cardContent}>
							<MD.Typography
								gutterBottom={true}
								variant="h4"
								component="h2"
							>
								<SvgIcon
									component={YacastLogoIcon}
									htmlColor={theme.palette.text.primary}
								/>
							</MD.Typography>

							<MD.Typography
								variant="caption"
								color="textSecondary"
								component="p"
							></MD.Typography>
							{this.getForm()}
						</MD.CardContent>
					</MD.CardActions>
				</MD.Card>
			</React.Fragment>
		);
	}

	private validateForm(): boolean {
		const errors = {
			name: this.state.params.name.trim() === '',
			type: this.state.params.type === -1,
			parent: this.state.resourceHasParent && this.state.params.parentID === -1
		};

		this.setState({ errors });
		return !Object.values(errors).some(error => error);
	}

	private getForm(): React.ReactNode {
		const { classes } = this.props;
		return (
			<form
				className={classes.form}
				noValidate={true}
				onSubmit={this.onSubmit.bind(this)}
			>
				<MD.InputLabel className={classes.label}>
					{this.props.i18n._('Name')}
					<span className={classes.required}>*</span>
				</MD.InputLabel>
				<DensedTextField
					margin="normal"
					value={this.state.params.name}
					error={this.state.errors.name}
					helperText={this.state.errors.name ? this.props.i18n._('Name is required') : ''}
					onChange={(event: any) => {
						this.setState({
							...this.state,
							params: {
								...this.state.params,
								name: event.target.value,
							},
							errors: {
								...this.state.errors,
								name: false,
							},
						});
					}}
				/>
				<MD.InputLabel className={classes.label}>
					{this.props.i18n._('Resource will be a parent ?')}
				</MD.InputLabel>
				<MD.FormControlLabel
					control={
						<MD.Switch
							checked={this.state.params.isparent}
							onChange={(
								event: React.ChangeEvent<HTMLInputElement>
							) => {
								this.setState({
									...this.state,
									params: {
										...this.state.params,
										isparent: event.target.checked,
									},
								});
							}}
							name="isParent"
						/>
					}
					label={this.props.i18n._('Resource is parent')}
				/>
				<MD.InputLabel className={classes.label}>
					{this.props.i18n._('Resource has a parent ?')}
				</MD.InputLabel>
				<MD.FormControlLabel
					control={
						<MD.Switch
							checked={this.state.resourceHasParent}
							onChange={(
								event: React.ChangeEvent<HTMLInputElement>
							) => {
								this.setState({
									...this.state,
									resourceHasParent: event.target.checked,
								});
							}}
							name="hasParent"
						/>
					}
					label={this.props.i18n._('Resource has parent')}
				/>
				{this.state.resourceHasParent ? (
					<Autocomplete
						options={
							this.props.resourcesManagement
								.allACLResourcesParents
						}
						onChange={(ev: React.ChangeEvent<{}>, val: any) => {
							if (
								!isNullOrUndefined(val) &&
								!isNullOrUndefinedOrEmptyString(val.name)
							) {
								this.setState({
									...this.state,
									params: {
										...this.state.params,
										parentID: val.id,
										parentName: val.name,
									},
									errors: {
										...this.state.errors,
										parent: false,
									},
								});
							} else {
								this.setState({
									...this.state,
									params: {
										...this.state.params,
										parentID: -1,
										parentName: '',
									},
								});
							}
						}}
						getOptionLabel={(option) => option.name}
						renderInput={(
							params: AutocompleteRenderInputParams
						) => (
							<MD.TextField
								{...params}
								label={
									<React.Fragment>
										{this.props.i18n._('Research Parent')}
										<span className={classes.required}>*</span>
									</React.Fragment>
								}
								error={this.state.errors.parent}
								helperText={this.state.errors.parent ? this.props.i18n._('Parent is required') : ''}
								value={this.state.params.parentName}
							/>
						)}
					/>
				) : (
					<React.Fragment></React.Fragment>
				)}

				<Autocomplete
					options={
						this.props.resourcesManagement.allACLResourcesTypes
					}
					onChange={(ev: React.ChangeEvent<{}>, val: any) => {
						if (
							!isNullOrUndefined(val) &&
							!isNullOrUndefinedOrEmptyString(val.name)
						) {
							this.setState({
								...this.state,
								params: {
									...this.state.params,
									type: val.id,
									typeName: val.name,
								},
								errors: {
									...this.state.errors,
									type: false,
								},
							});
						} else {
							this.setState({
								...this.state,
								params: {
									...this.state.params,
									type: -1,
									typeName: '',
								},
							});
						}
					}}
					getOptionLabel={(option) => option.name}
					renderInput={(params: AutocompleteRenderInputParams) => (
						<MD.TextField
							{...params}
							label={
								<React.Fragment>
									{this.props.i18n._('Research Type')}
									<span className={classes.required}>*</span>
								</React.Fragment>
							}
							error={this.state.errors.type}
							helperText={this.state.errors.type ? this.props.i18n._('Type is required') : ''}
							value={this.state.params.typeName}
						/>
					)}
				/>

				<MD.Button
					className={classes.button}
					color="primary"
					variant="contained"
					onClick={this.onSubmit.bind(this)}
					disabled={this.props.isCreatingResource}
				>
					{this.props.isCreatingResource ? (
						<MD.CircularProgress size={24} color="inherit" />
					) : (
						this.props.i18n._('Create')
					)}
				</MD.Button>

				<MD.Button
					className={classes.button}
					color="secondary"
					variant="contained"
					onClick={this.onReset.bind(this)}
				>
					{this.props.i18n._('Reset Form')}
				</MD.Button>
			</form>
		);
	}

	private onSubmit() {
		if (this.validateForm()) {
			this.state.resourceHasParent
				? this.props.addACLResource(
						this.props.user.token,
						this.state.params.name,
						this.state.params.type,
						this.state.params.isparent,
						this.state.params.parentID
				  )
				: this.props.addACLResource(
						this.props.user.token,
						this.state.params.name,
						this.state.params.type,
						this.state.params.isparent
				  );
		}
	}
	private onReset() {
		this.setState({
			...initialState,
		});
	}
}

const mapStateToProps = (
	{ i18n, user, resourcesManagement }: IApplicationState,
	ownProps: RouteComponentProps<IRouterMatchParams>
) => ({
	i18n: i18n.i18n,
	router: ownProps,
	user,
	resourcesManagement,
	isCreatingResource: resourcesManagement.isCreatingResource,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
	getACLResourcesParents: (token: string) =>
		dispatch(getACLResourcesParents(token)),
	getACLResourcesTypes: (token: string) =>
		dispatch(getACLResourcesTypes(token)),
	addACLResource: (
		token: string,
		name: string,
		type: number,
		isparent: boolean,
		parentID?: number
	) => dispatch(addACLResource(token, name, type, isparent, parentID)),
});

export const ResourceManagementCreation = connect(
	mapStateToProps,
	mapDispatchToProps
)(MD.withStyles(styles)(ResourceManagementCreationComponent));
